import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { ClaimService } from 'app/services/claim-service';
import { CommonsText } from 'app/commons/CommonsText';

export interface ConsultaLegalCard {
    titulo: string;
    descripcion: string;
    fechaApertura: string;
    abogado: string;
    estado: string;
}

@Component({
    selector: 'app-legal-queries-page',
    templateUrl: './legal-queries-page.component.html',
    styleUrls: ['./legal-queries-page.component.scss']
})
export class LegalQueriesPageComponent implements OnInit {

    loading: boolean = false;
    consultas: ConsultaLegalCard[] = [];

    detailOpen: boolean = false;
    selectedConsulta: ConsultaLegalCard = null;

    constructor(private router: Router,
                private claimService: ClaimService,
                private toastr: ToastrService) {}

    ngOnInit(): void {
        this.load();
    }

    /** Abre el modal con el detalle de la consulta seleccionada. */
    irDetalle(card: ConsultaLegalCard): void {
        this.selectedConsulta = card;
        this.detailOpen = true;
    }

    closeDetail(): void {
        this.detailOpen = false;
        this.selectedConsulta = null;
    }

    /** Carga todas las consultas de siniestros del usuario logado (sin paginar). */
    private load(): void {
        this.loading = true;
        this.claimService.listAll()
            .then(page => {
                this.loading = false;
                const list = (page && page.content) ? page.content : [];
                this.consultas = list.map(c => ({
                    titulo: [c.queryTypeDescription, c.querySubtypeDescription].filter(Boolean).join(': '),
                    descripcion: c.description || '',
                    fechaApertura: c.date || '',
                    abogado: c.handlerName || '',
                    estado: ''
                } as ConsultaLegalCard));
            })
            .catch(() => {
                this.loading = false;
                this.consultas = [];
                this.toastr.error(CommonsText.PROBLEMA_SERVICIO_CONSULTAS,
                                  CommonsText.PROBLEMA_DE_CONECTIVIDAD,
                                  { timeOut: 5000 });
            });
    }
}
